<template>
  <div class="page-index">
    <div class="page-nav">
      <div class="nav-item"
        :class="type === 1 ? 'item-checked' : ''"
        @click="changeType(1)">
        景区
        <div class="nav-item-line"></div>
      </div>
      <div
        class="nav-item"
        :class="type === 2 ? 'item-checked' : ''"
        @click="changeType(2)">
        文博场馆
        <div class="nav-item-line"></div>
      </div>
    </div>
    <div class="index-list"
      v-infinite-scroll="getScenicList"
      infinite-scroll-immediate-check="false"
      infinite-scroll-disabled="loading"
      id="scroll_area_box"
      infinite-scroll-distance="0">
      <div
        class="list-item"
        v-for="data in scenicList"
        :key="data.id"
        >
        <div class="item-top">
          <img :src="data.picUrl" alt="">
          <div class="item-name">
            {{data.name}}
            <div class="border-lb"></div>
            <div class="border-rt"></div>
          </div>
          <div class="item-level" v-show="data.level != -1">
            <div class="level-h-line"></div>
            <div class="level-v-line-s"></div>
            <div class="level-v-line-l"></div>
            <div class="level-text">{{data.levelName}}</div>
            <div class="level-v-line-l"></div>
            <div class="level-v-line-s"></div>
            <div class="level-h-line"></div>
          </div>
        </div>
        <div class="item-content">
          <div class="content-text">每天{{data.startTime}}-{{data.endTime}}</div>
          <div class="content-text">支持提前{{data.advanceBooking}}天预约</div>
          <div class="content-btn" role="button" @click="toTips(data)" v-if="data.status === 1">
            立即预约
          </div>
          <div class="content-btn btn-disabled" role="button" v-else>
            {{data.status === 2 ? '暂未开放预约' : '已约满'}}
          </div>
        </div>
      </div>
    </div>
    <v-bottom></v-bottom>
  </div>
</template>

<script type="text/javascript">
import { Toast, Indicator } from 'mint-ui'
import Bottom from '@/components/Bottom'
export default{
  components: {
    'v-bottom': Bottom
  },
  data () {
    return {
      loading: false,
      allLoaded: false,
      start: 0,
      limit: 10,
      isFirst: true,
      type: 1, // 1 景区 2 场馆
      scenicList: []
    }
  },
  methods: {
    // 切换列表类型
    changeType (type) {
      let that = this
      that.type = type
      that.start = 0
      that.scenicList = []
      that.allLoaded = false
      that.getScenicList()
    },
    // 获取景区列表
    async getScenicList () {
      let that = this
      if (that.allLoaded) {
        that.loading = true
        return
      }
      that.loading = true
      try {
        Indicator.open()
        let result = await that.$api({
          method: 'get',
          url: '/bookingSite/list',
          params: {
            type: that.type,
            start: that.start,
            limit: that.limit,
            areaId: -1
          }
        })
        Indicator.close()
        if (result.code === 2000 && result.result) {
          let res = result.result
          let arr = res.info || []
          that.scenicList = [...that.scenicList, ...arr]
          if (that.scenicList.length === res.total) {
            that.allLoaded = true
          } else {
            that.start += that.limit
          }
        } else {
          Toast({
            message: result.message,
            duration: 2000
          })
        }
      } catch (e) {
        console.log(e)
        Indicator.close()
      }
      that.loading = false
    },
    toTips (data) {
      this.setSession('scenic', data)
      this.$router.push({
        path: '/tips'
      })
    }
  },
  mounted () {
    this.getScenicList()
    document.title = '预约列表'
  }
}
</script>

<style type="text/css" lang="scss" scoped>
.page-index{
  width: 100%;
  height: 100%;
  position: relative;
  background-image: linear-gradient(0deg, #94B8FF 0%, #5D94FF 100%);
  display: flex;
  flex-direction: column;
  .page-nav{
    width: 100%;
    height: .26rem;
    display: flex;
    box-sizing: border-box;
    padding: 0 .5rem;
    margin-top: .15rem;
    .nav-item{
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      height: 100%;
      font-size: .16rem;
      color: #FFFFFF;
      .nav-item-line{
        display: none;
      }
    }
    .item-checked{
      font-weight: bold;
      .nav-item-line{
        display: block;
        width: .45rem;
        height: .02rem;
        background: #FFFFFF;
        border-radius: .1rem;
      }
    }
  }
  .index-list{
    flex: 1;
    margin-top: .15rem;
    width: 100%;
    box-sizing: border-box;
    padding: 0 .15rem .15rem;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    -ms-overflow-style: none;
    overflow: -moz-scrollbars-none;
    .list-item{
      width: 100%;
      height: 2.34rem;
      background: #FFFFFF;
      box-shadow: 0 .02rem .04rem 0 rgba(0,0,0,0.16);
      border-radius: .04rem .04rem 0 0;
      overflow: hidden;
      ~.list-item{
        margin-top: .1rem
      }
      .item-top{
        width: 100%;
        height: 1.70rem;
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        img{
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
        }
        .item-name{
          margin-top: .47rem;
          min-width: 1.8rem;
          height: .3rem;
          line-height: .3rem;
          text-align: center;
          box-sizing: border-box;
          padding: 0 .13rem;
          background: rgba(0,42,83,.5);
          font-size: .16rem;
          color: #FFFFFF;
          font-weight: bold;
          position: relative;
          .border-lb{
            width: .83rem;
            height: .142rem;
            border-left: 1px solid rgba(236,240,255,0.67);
            border-bottom: 1px solid rgba(236,240,255,0.67);
            position: absolute;
            left: -.02rem;
            bottom: -.02rem;
          }
          .border-rt{
            width: .83rem;
            height: .142rem;
            border-right: 1px solid rgba(236,240,255,0.67);
            border-top: 1px solid rgba(236,240,255,0.67);
            position: absolute;
            top: -.02rem;
            right: -.02rem;
          }
        }
        .item-level{
          height: .2rem;
          display: flex;
          align-items: center;
          position: relative;
          margin-top: .06rem;
          .level-h-line{
            width: .37rem;
            height: 1px;
            background: rgba(255,255,255,1);
          }
          .level-v-line-s{
            width: .02rem;
            height: .06rem;
            background: #FFFFFF;
          }
          .level-v-line-l{
            width: .02rem;
            height: .1rem;
            background: #FFFFFF;
            margin-left: .02rem;
            ~.level-v-line-l{
              margin-right: .02rem;
            }
          }
          .level-text{
            box-sizing: border-box;
            padding: 0 .06rem;
            min-width: .63rem;
            font-size: .14rem;
            font-weight: bold;
            color: #FFFFFF;
            text-align: center;
            text-shadow: 0 2px 4px rgba(30,30,30,0.92);
          }
        }
      }
      .item-content{
        width: 100%;
        height: .64rem;
        box-sizing: border-box;
        padding: .1rem .12rem;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        position: relative;
        .content-text{
          font-size: .14rem;
          color: #333333;
        }
        .content-btn{
          width: 1.08rem;
          height: .28rem;
          line-height: .28rem;
          text-align: center;
          border-radius: .145rem;
          background-image: linear-gradient(270deg, #6398FF 0%, #3F80FF 100%);
          box-shadow: 0 .02rem .04rem 0 rgba(67,107,196,0.50);
          position: absolute;
          top: 50%;
          margin-top: -.14rem;
          right: .15rem;
          font-size: .12rem;
          color: #FFFFFF;
          font-weight: bold;
        }
        .btn-disabled{
          background: #B3B3B3;
          box-shadow: 0 2px 4px 0 rgba(109,110,112,0.50);
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Index.vue